/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import React from "react";
import elementValidation from '../Component/validation.js';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
import FormRenderer from '../Component/Forms/FormRenderer';
import ThemeControls from "../Component/AllThemesControl";
import { Form } from '../Component/Forms/formElement';
import { MasterContext } from '../services/MasterContext';
import { APIPOST, APIPATCH, APIGET } from '../services/APIServices';
import { BiSolidPlusCircle, BiSolidMinusCircle } from "react-icons/bi";

function TabPanels(props) {
  const [openTab, setOpenTab] = React.useState(0);
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const { contextJson, contextObjective, apiContextObj, setEditData } = React.useContext(FormJSONCreateContext);
  function cardOpen(index) {
    setOpenTab(prevTab => (prevTab === index ? -1 : index));
  }

  const objData = Object.keys(contextJson).map((key, index) => {
    if (key !== "xioFEConfig" && contextJson[key].display_on_create !== "hide" && contextObjective === 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
          </div>
          <div className="rowFrom">
            <FormRenderer formJSON={contextJson[key]} formType={props.formType}/>
          </div>
        </div>
      );
    } else if (key !== "xioFEConfig" && contextObjective !== 'create') {
      return (
        <div value={contextJson[key].page_label} key={index} className={openTab === index ? `${classes.formTabCard}` : `${classes.formTabCard2}`}>
          <div className={classes.formTabheading}>
            <div className="flexIcon">{openTab === index ? (
              <BiSolidMinusCircle onClick={() => cardOpen(index)} />
            ) : (
              <BiSolidPlusCircle onClick={() => cardOpen(index)} />
            )}
              <h1 onClick={() => cardOpen(index)}>{contextJson[key].page_label}</h1>
            </div>
          </div>
          <FormRenderer formJSON={contextJson[key]} formType={props.formType}/>
        </div>
      );
    }
    return null;
  });

  return objData;
}

function TabFormRow(props) {
  const { useStyles } = ThemeControls;
  const classes = useStyles();
  const [postResponse, setPostResponse] = React.useState();
  const { contextJson, renderSuccessPage } = React.useContext(FormJSONCreateContext);
  const {apiContextObj, contextObjective, editData, contextDataArr, contextIndex } = React.useContext(FormJSONCreateContext);
  const { masterData } = React.useContext(MasterContext);
  const [disableBtn, setDesable] = React.useState(false);
  
  function hendleErrorMsg(msg) {
    // //console.log(msg)
  }
  function preprocessFieldValues(fields) {
    return fields.map(field => {
      if (Array.isArray(field.field_value)) {
        field.field_value.forEach(item=>{
          if(item=== ""){
            field.field_value = "";
          }
        })
      }
      return field;
    });
  }
  function validateThisForm(jsonContext) {
    // jsonContext.fields = preprocessFieldValues(jsonContext.fields);
    let return_error = true;
    jsonContext.fields.forEach(field => {
      if (!elementValidation(field)) {
        return_error = false;
         
        return false;
      }
    });
    return return_error;
  }

  async function handleSubmit(event) {

    event.preventDefault();
    window.scrollTo(0, 0);
    //console.log("Submit Cliked")
    let isFormValid = true;
    window.scrollTo(0, 0);
    const fdata = {};
    let Arry = [];
    let data;

    Object.keys(contextJson).forEach((key) => {
      if (key !== "xioFEConfig") {
        const form = contextJson[key];
        isFormValid = validateThisForm(form)
        if (isFormValid && validateThisForm(form)) {
          form.fields.forEach((thisField) => {
            const { field_type, field_id, field_value, field_keyValue, url } = thisField;

            if (field_type === "dragDropSelect") {
              Arry = field_value.split(', ').map(Number);
            } else if (field_value === "formJsonData") {
              fdata[field_id] = JSON.stringify(field_value);
            } else {
              fdata[field_id] = field_value
            }
          });
        }
      }
    });

    if (apiContextObj.apiContextSave === "gtsAminformation") {
      const result = Arry.map((carrierId) => ({ ...fdata, carrierid: carrierId }));
       
      data = [...result];
    } else {
      const keys = Object.keys(fdata);

      // Find the key with the longest split values
      const maxValues = Math.max(...keys.map(key => fdata[key].length));
 
      data = [];

      for (let i = 0; i < maxValues; i++) {
        const obj = {};
      
        keys.forEach((key) => {
          const values = fdata[key];
          // console.log(values);
          if (typeof values[i] === 'string' || values[i] instanceof String) {
            obj[key] = values[i].trim();
          } else {
            obj[key] = values[i] !== undefined ? values[i] : ''; // Handle missing values or non-string values
          }
        });
      
        data.push(obj);
      }
    }

    async function postingData(contextJson) {
      masterData[`${apiContextObj.apiContextSave}`] = {}
      try {
        const response = await APIPOST(apiContextObj.apiContextSave + '/saveAll', data, contextJson, renderSuccessPage, hendleErrorMsg);
        // setPostResponse(response.data);
        if (response) {
          // setPostResponse(response.data);
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    async function updateData(contextJson) {
      masterData[`${apiContextObj.apiContextSave}`] = {}
      try {
        const response = await APIPATCH(apiContextObj.apiContextSave + '/' + contextDataArr[contextIndex][apiContextObj.id], data, contextJson, renderSuccessPage, hendleErrorMsg);
        if (response) {
          setPostResponse(response.data);
          return response.data
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }


    if (isFormValid) {
      if (contextObjective === "create") {
        postingData(contextJson);
      } else if (contextObjective === "update") {
        updateData(contextJson)
      }
    } else {
      var msg = 'Please Check Form for errors!';
      // hendleErrorMsg(msg)
      alert(msg)
    }
    return false;
  }


  return (
    <>
      <TabPanels  formType={props.formType}/>
      <div className={classes.fromBtn}>
        <button className="smtbtn" type="submit" onClick={handleSubmit}>Submit</button>
      </div>
    </>
  );
}

export default TabFormRow;
